document.addEventListener('DOMContentLoaded', () => {
  const $tabs = document.getElementById('profile-nav');
  const anchors = $('#profile-nav a');

  if (!$tabs || anchors.length === 0) {
    return;
  }

  const STICKY_CLASS = 'fixed-tabs';
  const TABS_HEIGHT = 65;
  const SECTION_PADDING_TOP = 65;
  const SECTION_MARGIN_TOP = 58;
  const BIGGER_SECTION_POSSIBLE = 570;

  let counter = 0;
  let isScrolling = null;
  let firstAnchorSection = null;
  const $topBrandsSection = document.getElementById('top-brands');

  // With first anchor hash we can get the first section with the hash as id.
  anchors.toArray().forEach((anchor) => {
    if (anchor.hash) {
      // Ensure the first anchor has its section on the page.
      const anchorId = anchor.hash.substring(1, anchor.hash.length);
      const pageSection = document.getElementById(anchorId);

      if (pageSection) firstAnchorSection = pageSection;
    }
  });

  // Set Top Brands section as the first one if it exists.
  const firstSection = $topBrandsSection || firstAnchorSection || anchors[0];

  let firstSectionOffsetTop = firstSection.getBoundingClientRect().top + SECTION_PADDING_TOP + SECTION_MARGIN_TOP + TABS_HEIGHT;

  let linkTabCliked = -1;

  if (anchors.length > 0) {
    // We add a click event listener for every anchor in the view.
    anchors.each((index) => {
      anchors[index].addEventListener('click', () => onTabClick(index));
    });
  }

  function updateActiveTab() {
    let scrollPos = $(document).scrollTop() - SECTION_PADDING_TOP - SECTION_MARGIN_TOP;

    anchors.each(function () {
      const currLink = $(this);
      const refElement = $(currLink.attr('href'));

      if (linkTabCliked === -1 && (refElement && refElement.length)) { // if a link has been clicked, don't need to do the code below.
        if (refElement.position().top <= scrollPos) {
          if (refElement.position().top + refElement.height() > scrollPos) {
            $('#profile-nav ul li a').removeClass('active');

            currLink.addClass('active');
          }
        } else {
          currLink.removeClass('active');
        }
      }
    });
  }

  function fixTabs() {
    isOpen = !$('#header-content').hasClass('hidden')
    isBiggerOne = $('#menu-reviews').css('display') === 'block'
    if (isOpen && isBiggerOne) {
      firstSectionOffsetTop = firstSection.getBoundingClientRect().top + SECTION_PADDING_TOP + SECTION_MARGIN_TOP + TABS_HEIGHT + BIGGER_SECTION_POSSIBLE;
    }
    else {
      firstSectionOffsetTop = firstSection.getBoundingClientRect().top + SECTION_PADDING_TOP + SECTION_MARGIN_TOP + TABS_HEIGHT;
    }

    if (window.scrollY >= firstSectionOffsetTop) {
      document.body.classList.add(STICKY_CLASS);
    } else {
      document.body.classList.remove(STICKY_CLASS);
    }

    updateActiveTab();
  }

  function onTabClick(idx) {
    // Every section get an extra 60px padding top when fixed tabs is visible.
    const sectionPaddingTop = idx > 1 && counter === 0 ? SECTION_PADDING_TOP + SECTION_MARGIN_TOP : SECTION_PADDING_TOP;
    const extraPadding = idx * sectionPaddingTop;

    if (isScrolling !== null) {window.clearTimeout(isScrolling);}

    /* All the conditions with counter === 0, is to force to adjust each tabs position when clicking on them.
    */
    if (counter === 0 && idx === 1) {
      isScrolling = setTimeout(function() {
        window.scrollTo(0, document.documentElement.scrollTop + extraPadding - TABS_HEIGHT);
      }, 600);
    } else if (counter === 0 && idx === 2) {
      isScrolling = setTimeout(function() {
        window.scrollTo(0, document.documentElement.scrollTop + extraPadding - TABS_HEIGHT);
      }, 600);
    } else if (counter === 0 && idx > 1) {
      isScrolling = setTimeout(function() {
        window.scrollTo(0, document.documentElement.scrollTop + TABS_HEIGHT + sectionPaddingTop);
      }, 600);
    }

    counter += 1;
    linkTabCliked = idx;
  }

  var timer = null;
  window.addEventListener('scroll', function() {
    if(timer !== null) {
      clearTimeout(timer);
    }

    fixTabs();

    timer = setTimeout(function() {
      if (linkTabCliked > -1) {
        anchors.removeClass('active');
        anchors.eq(linkTabCliked).addClass('active');
        linkTabCliked = -1;
      }
    }, 150);
  }, false);
});
